module.exports = __webpack_public_path__ + "static/img/arthroscopy-10.0881af8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-10.jpg
// module id = auVY
// module chunks = 52